export interface Balance {
  amount: number
  currency: string
}

export interface InvalidPlayer {
  type: 'InvalidPlayer'
}

export interface AnonymousPlayer {
  type: 'AnonymousPlayer'
}

export interface InitializedPlayer {
  type: 'InitializedPlayer'
  token: string
  id: string
}

export interface AuthenticatedPlayer {
  type: 'AuthenticatedPlayer'
  token: string
  id: string
  username: string
  displayName: string
  sessionId: string
  balance: Balance
  // False while the real balance is still loading (non-blocking launch: the game
  // renders before the operator wallet balance arrives). Betting is hard-blocked
  // until this is true — `balance.amount` is a placeholder (0) until then.
  balanceLoaded: boolean
  language?: string
  country?: string
}

export type Player = InvalidPlayer | AnonymousPlayer | InitializedPlayer | AuthenticatedPlayer

export const invalidPlayer: InvalidPlayer = {
  type: 'InvalidPlayer'
}

export const anonymousPlayer: AnonymousPlayer = {
  type: 'AnonymousPlayer'
}

export const isAnonymousPlayer = (player: Player): player is AnonymousPlayer =>
  player.type === 'AnonymousPlayer'

export const isInvalidPlayer = (player: Player): player is InvalidPlayer =>
  player.type === 'InvalidPlayer'

export const isInitializedPlayer = (player: Player): player is InitializedPlayer =>
  player.type === 'InitializedPlayer'

export const isAuthenticatedPlayer = (player: Player): player is AuthenticatedPlayer =>
  player.type === 'AuthenticatedPlayer'
